import { Linkedin, Github } from 'lucide-react'
import { Button } from "./ui/Button"
import { useTheme } from "./ThemeContext"

export default function Footer() {
  const { theme } = useTheme()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <footer
      id="contact"
      className={`py-12 transition-colors duration-300 border-t ${
        theme === "dark" ? "bg-gray-900 border-gray-700" : "bg-white border-gray-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <div className="mb-4">
              <img
                src="/images/logo-harsh-vardhan.png"
                alt="Harsh Vardhan Logo"
                width={300}
                height={60}
                className="object-contain"
              />
            </div>
            <div className="flex items-center space-x-4 text-sm">
              <Button
                variant="link"
                onClick={scrollToTop}
                className={`p-0 transition-colors ${
                  theme === "dark" ? "text-white hover:text-yellow-400" : "text-gray-800 hover:text-blue-600"
                }`}
              >
                Back to Top
              </Button>
              <span className={`transition-colors ${theme === "dark" ? "text-white" : "text-gray-800"}`}>
                © 2025 | Developed by Harsh Vardhan
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-8">
            {/* Social Icons */}
            <div className="flex items-center space-x-4">
              <div className="bg-yellow-400 p-2 rounded hover:bg-yellow-500 transition-colors cursor-pointer">
                <a href="
                https://www.linkedin.com/in/harsh-vardhan-singh-26aba4227/" className="h-6 w-6 text-blue-600">
                <Linkedin className="" />
                  </a>
              </div>
              <div className="bg-yellow-400 p-2 rounded hover:bg-yellow-500 transition-colors cursor-pointer">
                <a href="https://github.com/harsh-vardhan1/" className="h-6 w-6 text-black">
                <Github className="h-6 w-6 text-black" />
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-2 text-sm">
              <div>
                <span className={`transition-colors ${theme === "dark" ? "text-gray-400" : "text-gray-600"}`}>
                  Email:
                </span>
                <a
                  href="mailto:vardhan6338@gmail.com"
                  className={`underline transition-colors ml-1 ${
                    theme === "dark" ? "text-white hover:text-yellow-400" : "text-gray-800 hover:text-blue-600"
                  }`}
                >
                  vardhan6338@gmail.com
                </a>
              </div>
              <div>
                <span className={`transition-colors ${theme === "dark" ? "text-gray-400" : "text-gray-600"}`}>
                  Phone:
                </span>
                <a
                  href="tel:7524035484"
                  className={`underline transition-colors ml-1 ${
                    theme === "dark" ? "text-white hover:text-yellow-400" : "text-gray-800 hover:text-blue-600"
                  }`}
                >
                  7524035484
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}